try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
    console.log("main js error", e);
}

const body = document.body;
const slideMenuBtn = document.getElementById('slide_menu_btn');
const slideMenuWrapper = document.getElementById('slide_menu_wrapper');
const slideMenuMask = document.getElementById('slide_menu_mask');
const slideMenuLink = document.querySelectorAll('.slide_menu_link');
let isMenuOpen = false;

// header fixed
const headerEl = document.getElementById('header');
const sentinalEl = document.getElementById('header_sentinal');

const handler = (entries) => {
  if (!entries[0].isIntersecting) {
    headerEl.classList.add('header_fixed');
  } else {
    headerEl.classList.remove('header_fixed');
  }
}

// create the observer
const observer = new window.IntersectionObserver(handler);
// give the observer some dom nodes to keep an eye on
observer.observe(sentinalEl);

slideMenuBtn.addEventListener('click', function () {
    if (!isMenuOpen) {
        menu_expand();
    } else {
        menu_collaspe();
    }
});

slideMenuMask.addEventListener('click', function () {
    menu_collaspe();
});

slideMenuLink.forEach(item => {
    item.addEventListener('click', e => {
        menu_collaspe();
    })
  })

// for lottie animation
const lottie_container = document.querySelectorAll('.lottie_container');
for (i = 0; i < lottie_container.length; ++i) {
  const data_id = lottie_container[i].dataset.id;
  const data_path = '/images/lottie/'+ data_id +'.json';
  lottie.loadAnimation({
      container: lottie_container[i],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: data_path
  })
}


function menu_expand() {
    body.classList.add('menu_active');
    slideMenuBtn.classList.add('active');
    slideMenuBtn.setAttribute('data-gtm-value', '0');
    slideMenuWrapper.classList.add('active');
    slideMenuWrapper.style.transition = "height .3s cubic-bezier(0.0, 0.0, 0.2, 1) .1s";
    isMenuOpen = true;
}

function menu_collaspe() {
    body.classList.remove('menu_active');
    slideMenuBtn.classList.remove('active');
    slideMenuBtn.setAttribute('data-gtm-value', '1');
    slideMenuWrapper.classList.remove('active');
    slideMenuWrapper.style.transition = "height .25s cubic-bezier(0.4, 0.0, 1, 1) .1s";
    isMenuOpen = false;
}

// search inputs
let search_form = document.getElementsByClassName("search_form");
// get keyword after searched
let current_keyword = decodeURIComponent(window.location.search.replace('?q=', ''));

// handle search inputs
Array.prototype.forEach.call(search_form, function(form) {
    let input = form.querySelector("input");
    let btn_close = form.querySelector(".btn_close");

    // check if is searched
    if(current_keyword && current_keyword !== "") {
        input.value = current_keyword;
        input.closest("form").classList.add("hasValue");
    } else {
        let search_page_form = document.getElementById("search_page_form");
        if (search_page_form) {
            document.getElementById("search_page_form").classList.add("initSearch");
        }
    }

    // handle inputs change
    input.addEventListener("input", (el)=> {
        let current_value = el.target.value;
        let current_form = el.target.closest("form");

        // check value
        if(current_value !== "") {
            current_form.classList.add("hasValue");
        } else {
            current_form.classList.remove("hasValue");
        }
    });

    // close btn
    btn_close.addEventListener("click", (el)=>{
        let target_form = el.target.closest("form");
        let target_input = target_form.querySelector("input");
        target_form.classList.remove("hasValue");
        target_input.value = "";
    });
});

